import { render, staticRenderFns } from "./DashboardPolicyMdtView.vue?vue&type=template&id=0b64f4e4&"
import script from "./DashboardPolicyMdtView.vue?vue&type=script&lang=ts&"
export * from "./DashboardPolicyMdtView.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports